import { reportIdToReportCategoryId } from 'app/area/case-report/case-listing/report-to-category-mapping';
import * as React from 'react';
import { Switch } from 'ui/common/switch/switch';

import styles from './case-report-view.scss';

interface CaseReportViewProps {
  classNames: string;
  fetching: boolean;
  report: number;
  hideLoadResults: boolean;
  hideNumberOfHits: boolean;
  translation: any;
  autoExecute: boolean;
  toggleAutoExecution: () => void;
  totalNumberOfResults?: number;
  children: JSX.Element;
}

export const CaseReportView = ({
  classNames,
  fetching,
  report,
  hideLoadResults, 
  hideNumberOfHits, 
  autoExecute,
  toggleAutoExecution, 
  totalNumberOfResults, 
  translation,
  children
}: CaseReportViewProps) => {
  const reportCategory = reportIdToReportCategoryId(report);
  const reportStyleClass = reportCategory ? ` report-category-${reportCategory}` : '';  
  const resultCount = !fetching && totalNumberOfResults > 0 && autoExecute;
  
  return (
    <div className={`${classNames}${reportStyleClass}`}>
      {(!hideLoadResults || !hideNumberOfHits) && <div className={styles.uiSearchHits}>
        {!hideNumberOfHits && <div className={styles.hits}>
          {resultCount && `${totalNumberOfResults} ${translation.search_hits}`}
        </div>}
        {!hideLoadResults && <div className={styles.switch}>
          <Switch
            className={styles.selectSwitch}
            checked={autoExecute}
            onChange={toggleAutoExecution}
            label={translation.toggle_info_load_options}
          />
        </div>}
      </div>}
      {children}
    </div>
  );
};
